import React, { useEffect } from 'react';

import { pushGtmEvent } from 'analytics/gtm';
import { Alert, InfoBox, Select } from 'design-system';
import { ReactComponent as AtencionIcon } from 'design-system/assets/atencion.svg';
import { useMediaQuery } from 'react-responsive';

import { useBases } from '../hooks/useBases';
import { REFUEL_MESSAGES } from '../constants';

import {
  AlertMessage,
  BaseWrap,
  Container,
  Divider,
  FieldLabel,
  ForecastWrap,
  PreviewData,
  SelectWrap,
  TopRow,
} from './styles';

const PreviewRefuel: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const {
    getBases,
    isLoading,
    bases,
    selectedBase,
    addSelectedBase,
    isUniqueBase,
    nextRefuelDate,
  } = useBases();

  useEffect(() => {
    getBases();
  }, [getBases]);

  const alertContent = (): React.ReactNode => {
    if (!selectedBase) {
      return REFUEL_MESSAGES.SELECT_BASE;
    }

    if (nextRefuelDate) {
      return (
        <AlertMessage
          dangerouslySetInnerHTML={{
            __html: REFUEL_MESSAGES.PREVIEW_DESCRIPTION,
          }}
        />
      );
    }

    return REFUEL_MESSAGES.UNABLE_TO_CALCULATE;
  };

  return (
    <Container>
      {!isLoading && bases?.length > 0 && (
        <PreviewData>
          <TopRow>
            <BaseWrap>
              <FieldLabel htmlFor="local-abastecimento">
                Central de abastecimento <span>*</span>
              </FieldLabel>
              <SelectWrap>
                <Select
                  id="local-abastecimento"
                  fullWidth
                  disabled={isUniqueBase}
                  borderColor="#262626"
                  color="#262626"
                  value={selectedBase?.name || ''}
                  onChange={(event) => {
                    const v = event.currentTarget.value;
                    pushGtmEvent({
                      event: 'click_cta',
                      eventCategory: 'home',
                      eventAction: 'click',
                      eventLabel: v || 'Local de abastecimento',
                      pageSection: 'home',
                      elementType: 'select',
                    });
                    addSelectedBase(v);
                  }}
                >
                  {!selectedBase && <option value="">Selecione</option>}
                  {bases.map((base) => (
                    <option key={base.name} value={base.name}>
                      {base.nickname}
                    </option>
                  ))}
                </Select>
              </SelectWrap>
            </BaseWrap>

            {nextRefuelDate && (
              <ForecastWrap>
                <InfoBox
                  size={isMobile ? 'sm' : 'md'}
                  backgroundColor={isMobile ? '#f5f5f5' : undefined}
                  borderColor={isMobile ? '#ececec' : undefined}
                  color="#575757"
                  highlight={nextRefuelDate}
                >
                  Previsão do próximo abastecimento:
                </InfoBox>
              </ForecastWrap>
            )}
          </TopRow>

          <Divider />

          <Alert
            variant="warning"
            icon={<AtencionIcon />}
            backgroundColor="#FFF8E6"
            borderColor="#F8C953"
            color="#575757"
          >
            {alertContent()}
          </Alert>
        </PreviewData>
      )}
    </Container>
  );
};

export default PreviewRefuel;
